// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  accountId: __t.string().name("account_id"),
  accountName: __t.string().name("account_name"),
  type: __t.string(),
  kycStatus: __t.string().name("kyc_status"),
  amlStatus: __t.string().name("aml_status"),
  accreditedStatus: __t.string().name("accredited_status"),
  raw: __t.string(),
});
